// Copyright (c) 2026 Isolated Networks. All rights reserved.
// Proprietary and confidential. Unauthorized copying, distribution, or use
// of this file, via any medium, is strictly prohibited.
// SPDX-License-Identifier: LicenseRef-Proprietary

// Utility functions to parse AT command responses

export function parseOperator(atCops) {
  // Example: '+COPS: 0,0,"T-Mobile",7' => 'T-Mobile'
  if (!atCops) return '—';
  const match = atCops.match(/\+COPS: \d+,\d+,"([^"]+)"/);
  return match ? match[1].trim() : atCops;
}
